import { Link } from 'react-router-dom';
import { categories } from '@/mocks/sportsData';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="py-14 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="font-heading font-bold text-2xl text-background-50 whitespace-nowrap">
              九游体育
            </Link>
            <p className="mt-4 text-sm text-background-400 leading-relaxed max-w-xs">
              九游体育是专业的体育赛事平台，为全球体育爱好者提供赛事直播、资讯、数据分析和互动社区服务。
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 text-sm mb-5">热门分类</h4>
            <ul className="flex flex-col gap-3">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 text-sm mb-5">快捷链接</h4>
            <ul className="flex flex-col gap-3">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">帮助中心</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 text-sm mb-5">联系我们</h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-base"></i>
                <span>contact@jiuyou-sports.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-base mt-0.5"></i>
                <span>北京市朝阳区体育中心路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 九游体育 Jiuyou Sports. All rights reserved.
          </p>
          <p className="text-xs text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200" rel="nofollow">京ICP备2024XXXXXXXX号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}